import React from "react";
import { Form, FormikProvider, useFormik } from "formik";

import { CustomButton, CustomDialog, FeaturedIcon } from "../../../components";

import css from "./modals.module.css";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";

const ModalValleyRepUnassign = ({
  open,
  onClose,
  onremoveComplete,
  valleyUser,
  valleyRepForAcct,
  account
}) => {

  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "unassignValleyRep",
    networkMode: "always",
    mutationFn: async () => 

      await RebatesClient.updateValleyRepAssignment({ 
        user_to_account_id: valleyRepForAcct?.user_to_account_id,
        user_id: valleyUser?.id,
        account_id: account?.id,
        action:  "unassign"
      })
    ,
    onError: (err) => { console.log(err) },
    onSuccess: (resp) => {console.log(resp)
      if (resp?.response?.status == 200) {
        onremoveComplete()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });

  const formik = useFormik({
    initialValues:{ },
    validationSchema:null,
    onSubmit: submitRequest
  });

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon="Trash" />
      Unassign Valley Rep
    </div>
  );

  return (
      <CustomDialog open={open} onClose={onClose} width={440} title={title}>
        <FormikProvider value={formik}>
          <Form className={css.modalForm}>
            <div className={css.formContent}>
              <div className={css.formGroup}>
                <p>Are you sure you want to unassign <strong>{valleyUser?.first_name} {valleyUser?.last_name}</strong> from <strong>{account?.name}</strong>? User will no longer receive any email updates for this account.</p>
              </div>
            </div>

            <div className={css.actions}>
              <CustomButton
                label="Unassign"
                type="submit"
                color="danger"
                onSubmit={formik.handleSubmit}
              />
            </div>
          </Form>
        </FormikProvider>
      </CustomDialog>
  );
}

export default ModalValleyRepUnassign;
